import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { ReactComponent as Icon } from 'src/Themes/assets/BigAlert.svg';
import st from './Development.module.scss';

interface IDevelopmentProps extends HTMLAttributes<HTMLDivElement> {
	withIcon?: boolean;
	color?: 'warn' | 'error' | 'info';
	text?: string;
	html?: string;
}

/**  */
const Development: FC<IDevelopmentProps> = ({
	text,
	withIcon = true,
	html,
	children,
	color = 'error',
	className,
	...otherProps
}) => {
	return (
		<div className={classNames(st.development, className)} {...otherProps}>
			<div className={classNames(st.alert, st[color])} {...otherProps}>
				{withIcon && <Icon />}
				{children ? (
					children
				) : html ? (
					<div dangerouslySetInnerHTML={{ __html: html }} />
				) : (
					text
				)}
			</div>
		</div>
	);
};

export default Development;
